import React from 'react';

import { useSubscriptionGuardQuery } from 'generated/graphql';
import { Navigate } from 'react-router-dom';



export const FC = ({
  children
}: {
  children: React.ReactNode | React.ReactNode[];
}) => {
  const { data, loading } = useSubscriptionGuardQuery();
  if (loading) {
    return null;
  }

  const memberships = data?.loggedInUser?.person.memberships ?? [];
  const someActive = memberships.some((m) => m.organization.hasActiveSubscription);
  if (!someActive) {
    return <Navigate to='/account' />;
  }

  return children;
};
